export default __webpack_public_path__ + "static/media/white_eye.977effb6.svg";